import { IContentViewItem } from '../../../../hooks/api/useContentView';

export const buildAdLegalTooltipText = (adItem: Pick<
    IContentViewItem,
    'erid' | 'teamFullName' | 'teamName' | 'teamInn' | 'adTeam'
>): string | null => {
    const erid = adItem.erid?.trim();
    const teamFullName = adItem.teamFullName?.trim();
    const teamName = adItem.teamName?.trim();
    const teamInn = adItem.teamInn?.trim();
    const adTeam = adItem.adTeam;

    const company =
        teamFullName
        || teamName
        || adTeam?.fullName?.trim()
        || adTeam?.name?.trim()
        || '';

    const inn = teamInn || adTeam?.inn?.trim() || '';

    let details = company;
    if (inn) {
        details = details ? `${details}, ИНН: ${inn}` : `ИНН: ${inn}`;
    }

    if (erid) {
        return details ? `ERID: ${erid}\n${details}` : `ERID: ${erid}`;
    }

    return details || null;
};
import { IContentViewItem } from '../../../../hooks/api/useContentView';

export const buildAdLegalTooltipText = (adItem: Pick<
    IContentViewItem,
    'erid' | 'teamFullName' | 'teamName' | 'teamInn' | 'adTeam'
>): string | null => {
    const erid = adItem.erid?.trim();
    const teamFullName = adItem.teamFullName?.trim();
    const teamName = adItem.teamName?.trim();
    const teamInn = adItem.teamInn?.trim();
    const adTeam = adItem.adTeam;

    const company =
        teamFullName
        || teamName
        || adTeam?.fullName?.trim()
        || adTeam?.name?.trim()
        || '';

    const inn = teamInn || adTeam?.inn?.trim() || '';

    let details = company;
    if (inn) {
        details = details ? `${details}, ИНН: ${inn}` : `ИНН: ${inn}`;
    }

    if (erid) {
        return details ? `ERID: ${erid}\n${details}` : `ERID: ${erid}`;
    }

    return details || null;
};
